export class ProviderInput {
    public BannerPath: String;
    public Format: String | Dropdown;
    public Id: Number;
    public Keyboard: String;
    public MaxLength: Number;
    public MinLength: Number;
    public Name: String;
    public PageOrder: Number;
    public Placeholder: String;
    public Required: Boolean;
    public ForRequest: Boolean;
    public IsHidden: Boolean;
    public DefaultValue: String;
    
    constructor(public providerInput: ProviderInput) {
        this.BannerPath = providerInput.BannerPath;
        this.Format = providerInput.Format;
        this.Id = providerInput.Id;
        this.Keyboard = providerInput.Keyboard;
        this.MaxLength = providerInput.MaxLength;
        this.MinLength = providerInput.MinLength;
        this.Name = providerInput.Name;
        this.PageOrder = providerInput.PageOrder;
        this.Placeholder = providerInput.Placeholder;
        this.Required = providerInput.Required;
        this.ForRequest = providerInput.ForRequest;
        this.IsHidden = providerInput.IsHidden;
        this.DefaultValue = providerInput.DefaultValue;
        if (this.Keyboard == 'dropdown') {
            this.Format = JSON.parse(this.Format.toString());
        } else if(this.Keyboard == null){
            this.Keyboard = 'text';
        }
    }
}

class Dropdown {
    public name: String;
    public value: String;
    
    constructor(public dropdown: Dropdown) {
        this.name = dropdown.name;
        this.value = dropdown.value;
    }
}